import { httpClient } from './httpClient';

const base = '/api/docentes';

export const listarDocentes = (filtros = {}) => {
  const params = new URLSearchParams();
  if (filtros.nombres) params.append('nombres', filtros.nombres);
  if (filtros.documento) params.append('documento', filtros.documento);
  if (filtros.email) params.append('email', filtros.email);
  if (filtros.activo !== undefined) params.append('activo', filtros.activo);
  
  const query = params.toString();
  return httpClient.get(query ? `${base}?${query}` : base);
};

export const obtenerDocente = (id) => httpClient.get(`${base}/${id}`);

export const obtenerDocentesPorCurso = (cursoId) => 
  httpClient.get(`${base}/curso/${cursoId}`);

export const crearDocente = (payload) => httpClient.post(base, payload);

export const actualizarDocente = (id, payload) => 
  httpClient.put(`${base}/${id}`, payload);

export const eliminarDocente = (id) => httpClient.del(`${base}/${id}`);

export const materiasQueDicta = (id) => httpClient.get(`${base}/${id}/materias`);

export const campusEstado  = (id)          => httpClient.get(`${base}/${id}/campus-estado`);
export const campusToggle  = (id, habilitar) => httpClient.post(`${base}/${id}/campus-toggle`, { habilitar });
export const campusReset   = (id)          => httpClient.post(`${base}/${id}/campus-reset`, {});

const docentesService = {
  listar: listarDocentes,
  obtener: obtenerDocente,
  obtenerPorCurso: obtenerDocentesPorCurso,
  crear: crearDocente,
  actualizar: actualizarDocente,
  eliminar: eliminarDocente,
  materiasQueDicta,
  campusEstado,
  campusToggle,
  campusReset,
};

export default docentesService;
